import DetectionModel from './src/DetectionModel.vue'

DetectionModel.install = function(Vue) {
    Vue.component(DetectionModel.name, DetectionModel)
}

export default DetectionModel